<template>
  <div class="list">
    <div class="label"><Upload v-if="!disabled" multiple :accept="accept" warpClass="btnupload" @change="handleAdd" /></div>
    <div v-for="(file,i) in fileList"
    :key="i">
      <item :file="file"
      :disabled="disabled"
      @on-edit="handleEdit"
      @on-view="handleView"
      @on-version="handleVersion"
      @on-down="handleDownload"
      @on-delete="handleDelete" />
    </div>
    <dialogView v-if="viewShow" :visible.sync="viewShow" :url="iframeURL"
    :title="isRead ? '预览': '编辑文件'"
    @on-close="handleCloseView" />
    <dialogVersion v-if="versionView" :visible.sync="versionView"
    :currentfile="currentfile"
    @on-down="handleDownload"
    @on-view="handleView" />
  </div>
</template>
<script>
import item from './item.vue'
import dialogView from './dialog'
import dialogVersion from './dialogVersion'
import { Upload, browserJudgment } from 'vue-gulp/dist'
import { API_CONFIG } from '@/page/config/base_config.js'
import _ from 'lodash'
export default {
  name: 'FileOnline',
  inject: ['viewFormData'],
  props: ['column', 'value'],
  components: {
    item,
    dialogView,
    dialogVersion,
    Upload
  },
  data() {
    const {
      accept,
      disabled
    } = this.column
    return {
      fileList: this.value || [],
      accept: accept || '*.*',
      versionView: false,

      currentfile: null,
      sheetShow: false,
      viewShow: false,
      iframeURL: null,
      disabled,
      isRead: false
    }
  },
  mounted() {
  },
  computed: {

  },
  watch: {
    fileList(val) {
      this.viewFormData.modelData[this.column.prop] = val
    }
  },
  methods: {
    async handleAdd(e) {
      const { files } = e.target
      if (files.length) {
        for (let i = 0; i < files.length; i++) {
          const file = files[i]
          await this.uploadServe(file)
          // this.setValue()
          // this.value = [...this.fileList]
          // this.$emit('input', [...this.fileList])
        }
      }
    },
    handleEdit(file) {
      const {
        fileUniqueCode
      } = file
      this.viewShow = true
      this.isRead = false
      this.webOfficeServe({
        fileUniqueCode,
        permission: 'write'
      })
    },
    handleView(file) {
      const {
        fileUniqueCode,
        version
      } = file
      this.viewShow = true
      this.isRead = true
      const params = {
        fileUniqueCode,
        permission: 'read'
      }
      if (version) {
        params.version = version
      }
      this.webOfficeServe(params)
    },
    handleVersion(file) {
      this.versionView = true
      this.currentfile = file
    },
    handleDelete(file) {
      const {
        fileUniqueCode
      } = file
      const index = _.findIndex(this.fileList, { fileUniqueCode })
      this.fileList.splice(index, 1)
    },
    handleCloseView() {
      this.viewShow = false
      this.refreshFileListServe()
    },
    handleDownload(file) {
      const {
        fastDFSGroupName,
        fastDFSPath,
        fileUniqueCode,
        fileName,
        version
      } = file
      const browserType = browserJudgment()
      let url = '/common/document/download'
      const params = {
        fileUniqueCode,
        fileName,
        doDownload: true
      }

      if (version) {
        url = '/common/document/download-his'
        params.version = version
      }

      if (browserType === 'ding' || browserType === 'wx') {
        window.open(`${API_CONFIG.FDFS_WEB_SERVER_URL}/${fastDFSGroupName}/${fastDFSPath}`)
      } else {
        this.$downloadFile
          .get(url, {
            params
          })
          .then(res => {
            if (res.code === 200) {
              this.$message({
                message: '文件下载成功！',
                type: 'success'
              })
            }
          })
          .catch(err => {
            if (err.msg) this.$message.error(err.msg)
            else this.$message.error(err.message)
          })
      }
    },
    async uploadServe(file) {
      let fd = new FormData()
      fd.append('file', file)
      fd.append('returnEntity', true)
      try {
        const { data, code } = await this.$http.post('/common/document/upload', fd, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })

        let item = {
          fileName: file.name,
          fastDFSGroupName: data.fastDFSGroupName,
          fastDFSPath: data.fastDFSPath,
          fileUniqueCode: data.fileUniqueCode,
          fileSize: data.fileSize,
          fileContentType: data.fileContentType,
          fastDFSThumbImagePath: data.fileContentType.startsWith('image/') ? '/' + data.fastDFSGroupName + '/' + data.fastDFSThumbImagePath : '',
          createUserName: data.createUserName,
          createTime: data.createTime,
          createUserId: data.createUserId,
          modifyTime: null,
          modifyUserId: null,
          modifyUserName: null
        }
        this.fileList.push(item)
      } catch (err) {
        console.log(err)
      }
    },
    async webOfficeServe(params) {
      try {
        const { data, code } = await this.$http.get('/common/document/weboffice/url', {
          params
        })
        this.iframeURL = data
      } catch (err) {
        console.log(err)
      }
    },
    async refreshFileListServe() {
      try {
        const { data, code } = await this.$http.post('/common/document/refresh-office-online', this.fileList)
        this.fileList = [...data]
      } catch (err) {
        console.log(err)
      }
    }
  },
  created() {

  }
}
</script>
<style lang="scss">
.list {
  padding: 10px 0;
}
.label {
  width: 100px;
  overflow: hidden;
  color: #FFF;
  border-radius: 4px;
  margin-top: -10px;
  margin-bottom: 15px;
}
.btnupload {
  background-color: #409EFF;
}
</style>
